export const SHOWME_ENERGY_START_REACTION_COUNT = 50;

/**
 * Return how many newly received reactions qualify for ShowMeEnergy.
 * The reaction that reaches the threshold is the first qualifying reaction.
 */
export const getNewEnergyReactionCount = (
  previousTotal,
  nextTotal,
  threshold = SHOWME_ENERGY_START_REACTION_COUNT,
) => {
  const safeThreshold = Math.max(1, Number(threshold) || 1);
  const safePreviousTotal = Math.max(0, Number(previousTotal) || 0);
  const safeNextTotal = Math.max(safePreviousTotal, Number(nextTotal) || 0);
  const reactionsBeforeEnergy = safeThreshold - 1;

  return Math.max(0, safeNextTotal - reactionsBeforeEnergy)
    - Math.max(0, safePreviousTotal - reactionsBeforeEnergy);
};
